import { DatePipe } from '@angular/common';
import { StatusEnum } from '../enums/status.enum';
import { TaskModel } from '../models/task.model';
import { TaskEnum } from '../enums/task.enum';
import { StatusColorEnum } from '../enums/status-color.enum';
import { StatusType } from '../types/status.type';
import { TaskType } from '../types/task.types';

export class Task {
    private datePipe = new DatePipe('fr-FR');

    constructor(private task: TaskModel) {}

    get data(): TaskModel {
        return this.task;
    }

    get id(): number | null {
        return this.task.id;
    }

    get status(): string {
        return Object.keys(StatusEnum).find(key => StatusEnum[key as keyof typeof StatusEnum] === this.task.status) || 'UNKNOWN';
    }

    get statusColor(): string {
        return StatusColorEnum[this.status as keyof typeof StatusColorEnum];
    }

    get type(): TaskType {
        return Object.keys(TaskEnum).find(key => TaskEnum[key as keyof typeof TaskEnum] === this.task.type) as TaskType || 'UNKNOWN';
    }

    get message(): string | null {
        return this.task.message;
    }

    get progress(): number | null {
        return this.task.progress;
    }

    get updatedAt(): string | null {
        return this.task.updated_at ? this.formatDate(this.task.updated_at) : null;
    }

    get createdAt(): string | null {
        return this.task.created_at ? this.formatDate(this.task.created_at) : null;
    }

    get deletedAt(): string | null {
        return this.task.deleted_at ? this.formatDate(this.task.deleted_at) : null;
    }

    get job(): number | null {
        return this.task.job;
    }

    private formatDate(date: Date): string {
        if (!(date instanceof Date)) {
            date = new Date(date);
        }
        const today = new Date();
        const diff = Math.abs(today.getDay() - date.getDay());
        if (diff === 0) {
            return 'Aujourd\'hui à ' + this.datePipe.transform(date, 'HH:mm:ss') || 'date not available';
        } else if (diff === 1) {
            return 'Hier à ' + this.datePipe.transform(date, 'HH:mm:ss') || 'date not available';

        } else if (diff === 2) {
            return 'Avant hier à ' + this.datePipe.transform(date, 'HH:mm:ss') || 'date not available';
        } else {
            return this.datePipe.transform(date, 'dd/MM/yyyy') || 'date not available';
        }
    }
}